__turbopack_context__.v({
  "form": "ResetPasswordModal-module-scss-module__CoyLla__form",
  "link": "ResetPasswordModal-module-scss-module__CoyLla__link",
  "resend": "ResetPasswordModal-module-scss-module__CoyLla__resend",
});
